var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 145.5,
    height: 145.5,
    viewBox: "0 0 145.5 145.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72.75,
    cy: 72.75,
    r: 72.75,
    transform: "translate(-9.3 10.68) rotate(-7.89)",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.31,50.45H91.39V47.31A12.08,12.08,0,0,0,79.32,35.25H51.19A12.08,12.08,0,0,0,39.12,47.31V83A12.08,12.08,0,0,0,51.19,95.05h2.92v3.14a12.08,12.08,0,0,0,12.07,12.06H94.31a12.08,12.08,0,0,0,12.07-12.06V62.52A12.08,12.08,0,0,0,94.31,50.45ZM54.11,62.52V90.05H51.19A7.08,7.08,0,0,1,44.12,83V47.31a7.07,7.07,0,0,1,7.07-7.06H79.32a7.07,7.07,0,0,1,7.07,7.06v3.14H66.18A12.08,12.08,0,0,0,54.11,62.52Zm47.27,35.67a7.07,7.07,0,0,1-7.07,7.06H66.18a7.07,7.07,0,0,1-7.07-7.06V62.52a7.08,7.08,0,0,1,7.07-7.07H94.31a7.08,7.08,0,0,1,7.07,7.07Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.a452dcad0dbc75d432a0453e8e30e2ed.svg";
export { ForwardRef as ReactComponent };